exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.loading_screen{\n    position: absolute;\n    float: right;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background-color: #ffffff78;\n}\n", ""]);

// exports
